export const state = {
  routes: [],
  dynamicRoutes: []
}
